export const TimeType = {
    PARTIAL: 'PARTIAL',
    TOTAL: 'TOTAL',

    values: () => {
        return ['PARTIAL', 'TOTAL'];
    }
}